import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { UserPrivilegeEnum } from '../../../../enums/rights/user-privilege.enum';
import { RFileType } from './r-file-type.action';
import { ResetStateDefaults } from '../../../base-action-class.model';

interface RFileTypeXsStateModel {
  viewGlobalFileType: string;
  createGlobalFileType: string;
  editGlobalFileType: string;
  deleteGlobalFileType: string;
}

const getDefaults = (): RFileTypeXsStateModel => ({
  viewGlobalFileType: null,
  createGlobalFileType: null,
  editGlobalFileType: null,
  deleteGlobalFileType: null,
});



@State<RFileTypeXsStateModel>({
  name: 'rFileType',
  defaults: getDefaults()
})
@Injectable()
export class RFileTypeXsState {

  // region Selectors
  @Selector()
  static viewGlobalFileType(state: RFileTypeXsStateModel): boolean {
    return state.viewGlobalFileType != null;
  }

  @Selector()
  static createGlobalFileType(state: RFileTypeXsStateModel): boolean {
    return state.createGlobalFileType != null;
  }

  @Selector()
  static editGlobalFileType(state: RFileTypeXsStateModel): boolean {
    return state.editGlobalFileType != null;
  }

  @Selector()
  static deleteGlobalFileType(state: RFileTypeXsStateModel): boolean {
    return state.deleteGlobalFileType != null;
  }
  // endregion

  // region Actions
  @Action(RFileType.SetFileTypePrivileges)
  public setFileTypePrivileges(ctx: StateContext<RFileTypeXsStateModel>, action: RFileType.SetFileTypePrivileges) {
    const state = ctx.getState();
    const designationPrivileges = [...action.activeUserRightInfoDtoModel.designationPrivileges];

    const viewGlobalFileType = designationPrivileges.find(id => id === UserPrivilegeEnum.VIEW_GLOBAL_DOCUMENT_TYPES);
    const createGlobalFileType = designationPrivileges.find(id => id === UserPrivilegeEnum.CREATE_GLOBAL_DOCUMENT_TYPE);
    const editGlobalFileType = designationPrivileges.find(id => id === UserPrivilegeEnum.EDIT_GLOBAL_DOCUMENT_TYPE);
    const deleteGlobalFileType = designationPrivileges.find(id => id === UserPrivilegeEnum.DELETE_GLOBAL_DOCUMENT_TYPE);

    ctx.setState({
      ...state,
      viewGlobalFileType: viewGlobalFileType,
      createGlobalFileType: createGlobalFileType,
      editGlobalFileType: editGlobalFileType,
      deleteGlobalFileType: deleteGlobalFileType,
    });
  }

  @Action(ResetStateDefaults)
  public resetDefaults(ctx: StateContext<RFileTypeXsStateModel>): void {
    ctx.setState({...getDefaults()});
  }
  // endregion

}
